import DropdownMultiselect from './DropdownMultiselect';

export default DropdownMultiselect;
